import {observer} from 'mobx-react-lite'
import {Link, Tooltip, Typography} from '@mui/material'
import {OcLinkProps} from './utils'
import {makeStyles} from '@oc/styles'

const useStyles = makeStyles({
    typographyStyle: {
        display: 'flex',
        alignItems: 'center'
    }
})

export function _OcLink(props: OcLinkProps) {
    const {children, tooltip, typographyClass, variant, color, ...restProps} = props
    const {classes, cx} = useStyles()

    return (
        <Tooltip title={tooltip || ''}>
            <Link underline="none" {...restProps}>
                <Typography
                    variant={variant || 'body1'}
                    color={color || 'inherit'}
                    className={typographyClass ? cx(typographyClass, classes.typographyStyle) : classes.typographyStyle}
                >
                    {children}
                </Typography>
            </Link>
        </Tooltip>
    )
}

export const OcLink = observer(_OcLink)
